/* eslint-disable @next/next/no-img-element */

import React from 'react';
import styles from './styles.module.scss';

interface IRichText {
  content?: string;
  children?: any;
}

const RichText = ({ content, children }: IRichText) => {
  if (content) {
    const formattedContent = content.replaceAll("<br>", "").replaceAll("&nbsp;", "")

    return (
      <div className={styles.richText} dangerouslySetInnerHTML={{__html: formattedContent}} />
    )
  }

  return (
    <div className={styles.richText} >
      { children }
    </div>
  )
};

export default RichText;
